"use strict";

var cov_17b82826wi = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\resources\\resourcesHelper.js";
  var hash = "bd326770fb951aed9953e0243602512dbdd76332";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\resources\\resourcesHelper.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 34
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 23
        },
        end: {
          line: 7,
          column: 25
        }
      },
      "2": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 19,
          column: 3
        }
      },
      "3": {
        start: {
          line: 10,
          column: 15
        },
        end: {
          line: 10,
          column: 44
        }
      },
      "4": {
        start: {
          line: 11,
          column: 15
        },
        end: {
          line: 11,
          column: 17
        }
      },
      "5": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 14,
          column: 5
        }
      },
      "6": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 44
        }
      },
      "7": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 40
        }
      },
      "8": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 44
        }
      },
      "9": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 24
        }
      },
      "10": {
        start: {
          line: 24,
          column: 34
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "11": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 39,
          column: 5
        }
      },
      "12": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "13": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 59
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 34
          },
          end: {
            line: 6,
            column: 35
          }
        },
        loc: {
          start: {
            line: 6,
            column: 60
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 34
          },
          end: {
            line: 24,
            column: 35
          }
        },
        loc: {
          start: {
            line: 30,
            column: 5
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 30
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 35,
            column: 11
          }
        },
        loc: {
          start: {
            line: 35,
            column: 31
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 35
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        }, {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        }],
        line: 12
      },
      "2": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }],
        line: 36
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "bd326770fb951aed9953e0243602512dbdd76332"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tryAddResourceLink = exports.removeResourceLink = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = require("react");

var _core = require("../../core");

cov_17b82826wi.s[0]++; // array.slice + re-join for resourceLinks array.

var removeResourceLink = function removeResourceLink(resourceLinks, index) {
  cov_17b82826wi.f[0]++;

  var _resourceLinks = (cov_17b82826wi.s[1]++, []);

  cov_17b82826wi.s[2]++;

  if (index > 0) {
    cov_17b82826wi.b[0][0]++;
    var head = (cov_17b82826wi.s[3]++, resourceLinks.slice(0, index));
    var tail = (cov_17b82826wi.s[4]++, []);
    cov_17b82826wi.s[5]++;

    if (index + 1 >= resourceLinks.length - 1) {
      cov_17b82826wi.b[1][0]++;
      cov_17b82826wi.s[6]++;
      tail = resourceLinks.slice(index + 1);
    } else {
      cov_17b82826wi.b[1][1]++;
    }

    cov_17b82826wi.s[7]++;
    _resourceLinks = [].concat((0, _toConsumableArray2.default)(head), (0, _toConsumableArray2.default)(tail));
  } else {
    cov_17b82826wi.b[0][1]++;
    cov_17b82826wi.s[8]++;
    _resourceLinks = resourceLinks.slice(1);
  }

  cov_17b82826wi.s[9]++;
  return _resourceLinks;
};

exports.removeResourceLink = removeResourceLink;
cov_17b82826wi.s[10]++;

var tryAddResourceLink = function tryAddResourceLink(resourceLinks, newResourceLink, reference, config, onResourceLinks) {
  cov_17b82826wi.f[1]++;
  cov_17b82826wi.s[11]++;
  (0, _core.resourceFromResourceLink)({
    resourceLink: newResourceLink,
    reference: reference,
    config: config
  }).then(function (_parsedResource) {
    cov_17b82826wi.f[2]++;
    cov_17b82826wi.s[12]++;

    if (_parsedResource != null) {
      cov_17b82826wi.b[2][0]++;
      cov_17b82826wi.s[13]++;
      onResourceLinks([].concat((0, _toConsumableArray2.default)(resourceLinks), [newResourceLink]));
    } else {
      cov_17b82826wi.b[2][1]++;
    }
  });
};

exports.tryAddResourceLink = tryAddResourceLink;